import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonLink } from '../components/ui/ButtonLink';
import { PageHero } from '../components/ui/PageHero';
import { usePageMeta } from '../hooks/usePageMeta';
const helpful = [{
  label: 'Our Expertise',
  to: '/expertise'
}, {
  label: 'Our Consultants',
  to: '/consultants'
}, {
  label: 'For Employers',
  to: '/employers'
}, {
  label: 'For Candidates',
  to: '/candidates'
}, {
  label: 'Contact Us',
  to: '/contact'
}];
export function NotFound() {
  usePageMeta('Page not found', 'The page you are looking for could not be found.');
  return <>
      <PageHero compact label="404" title="This page could not be found." intro="The link may be outdated, or the page may have moved." data-id="element-906" data-mp="1jtlsmafu2b5h">
        <ButtonLink to="/" size="lg" data-id="element-907" data-mp="1nuns8sdnwp7z">
          Return Home
        </ButtonLink>
        <ButtonLink to="/sitemap" variant="outline-light" size="lg" data-id="element-908" data-mp="1svuyuo42jid2">
          View Sitemap
        </ButtonLink>
      </PageHero>
      <section className="bg-porcelain py-16" data-id="element-909" data-mp="1xrir5cdukrms">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-910" data-mp="1nw3ykkev4772">
          <h2 className="font-display text-lg font-semibold text-aubergine" data-id="element-911" data-mp="1nthifwdwojd8">You may be looking for</h2>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-912" data-mp="1iz3qk3ygcudb">
            {helpful.map(h => <li key={h.to} data-id="element-913" data-mp="1ex9y2iyeuwo8">
                <Link to={h.to} className="inline-flex h-10 items-center rounded-full border border-plum/15 px-4 text-sm text-plum/80 hover:border-copper hover:text-copper-deep" data-id="element-914" data-mp="19wm6nw69sdth">
                  {h.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </section>
    </>;
}